export class ApproveEventsModel{
  StartDate : Date;
  EndDate : Date;
  JobNo : string;
  TaskGuid : string;
  ResourceNos : string[];
  IsApproved : boolean;
}




// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/ApproveEventsModel.ts